<template>
  <div class="Bg">
    <div class="container Login">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="card col-md-4">
          <div class="card-body">
            <div class="text-center logo-container">
              <img src="@/assets/img/mimicando-logo-alpha.png" width="256" class="center-block">
            </div>
            <form @submit.prevent="login">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input type="email" v-model="email" id="email" class="form-control" autocomplete="off" required>
              </div>
              <div class="form-group">
                <label for="password">Senha</label>
                <input type="password" v-model="password" id="password" class="form-control" autocomplete="off" required>
              </div>
              <div class="form-group">
                <div class="login-errors text-danger text-center">
                  {{ this.loginErrors }}
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-primary w-100"
                :disabled="isLoading"
              >
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isLoading"></span>
                <span v-if="!isLoading">Entrar</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      loginErrors: '',
      isLoading: false
    }
  },
  methods: {
    login () {
      this.isLoading = true

      try {
        firebase.auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then (
            (user) => {
              this.$router.push({
                name: 'packs'
              })
            },
            (err) => {
              this.isLoading = false
              this.loginErrors = err.message
            }
          )
      } catch (err) {
        this.loginErrors = err.message
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.Bg {
  background-image: url('../assets/img/mimicando-bg.png');
  background-repeat: repeat;
  background-size: 256px;
}

.Login {
  height: 100vh;
}

.login-errors {
  max-width: 100%;
  word-wrap: break-word;
}

.logo-container {
  margin-bottom: 16px;
}
</style>
